import React, { useState, useCallback } from 'react';
import TpSurveySearchParams from './TpSurveySearchParams';
import ProjectAssociableTpSurveyItem from '../../../Domain/ThirdParty/Project/ProjectAssociableTpSurveyItem';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TpSurveyService from '../../../Services/tpSurveyService';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import FigmaButton from '../../../Elements/FigmaButton';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import OverWindow from '../../../Elements/TabList/OverWindow';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TpSurveyActivateWindowDescription from './TpSurveyActivateWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';

const AssociateTpSurveyPanel = (props) => {
  const initialSearchItem = new TpSurveySearchParams();
  initialSearchItem.ProjectId = props.searchItem.ProjectId;
  initialSearchItem.IsAssocationSearch = true;
  initialSearchItem.IsActivated = '';

  const [itemList, setItemList] = useState([]);
  const [saving, setSaving] = useState(false);
  const [editedItem, setEditedItem] = useState(null);
  const [showedPanel, setShowedPanel] = useState(ShownPanelsEnum.None);
  const [searchItem, setSearchItem] = useState(initialSearchItem);

  // Set clickOnSelect as a static property for ProjectAssociableTpSurveyItem
  ProjectAssociableTpSurveyItem.clickOnSelect = (item) => {
    setItemList((prevList) =>
      prevList.map((element) =>
        element.TpSurveyId === item.TpSurveyId ? { ...element, Selected: !element.Selected } : element
      )
    );
  };

  ProjectAssociableTpSurveyItem.clickOnGlobalSelect = () => {
    const selectedStatus = itemList.some((item) => item.Selected === false) ? true : false;
    const templist = [...itemList];

    if (templist !== undefined && templist.length > 0) {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    setItemList(templist);
  };

  ProjectAssociableTpSurveyItem.selectedStatus = () => {
    return itemList.some((item) => item.Selected === false) ? false : true;
  };

  ProjectAssociableTpSurveyItem.clickOnDeactivateSurvey = (item) => {
    const edited = { ...item, IsActivated: false };
    TpSurveyService.ActivateDeacivateSurvey(edited)
      .then((result) => {
        if (result.errorMessage) {
          ErrorMessage.SetErrorMessage(result.errorMessage);
          return;
        }
        refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TSA47');
      });
  };

  ProjectAssociableTpSurveyItem.clickOnActivateSurvey = (item) => {
    setEditedItem({ ...item, IsActivated: true });
    setShowedPanel(ShownPanelsEnum.AddNewItem);
  };

  function refresh() {
    setShowedPanel(ShownPanelsEnum.None);
    setSearchItem({ ...searchItem });
  }

  const handleOnSubmit = useCallback(() => {
    setSaving(true);

    const selectedTpSurveyIds = itemList.filter((item) => item.Selected).map((item) => item.TpSurveyId);
    const temp = {
      Id: props.searchItem.ProjectId,
      TpSurveyIds: selectedTpSurveyIds,
    };

    ErrorMessage.SetNotification(
      'The survey association process started in the background. This might take some time, you will be notified via in-app notification when the process has finished.'
    );
    TpSurveyService.AssociateProjectTpSurvey(temp)
      .then((result) => {
        if (result && result !== 'None.' && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification(
            `The surveys: ${temp.TpSurveyIds} have been successfully associated with the project ${props.searchItem.ProjectId}.`
          );
        }
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: ASP88. Survey association failed. Please notify IT!');
      });

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        altKey: false,
        code: 'Escape',
        ctrlKey: false,
        isComposing: false,
        key: 'Escape',
        location: 0,
        metaKey: false,
        repeat: false,
        shiftKey: false,
        which: 27,
        charCode: 0,
        keyCode: 27,
      })
    );
  }, [itemList, props.searchItem.ProjectId]);

  function renderOnePanel(panelId, content) {
    return showedPanel === panelId ? content : null;
  }

  function renderPanels() {
    return (
      <div>
        {renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={editedItem}
            clickOnCancel={() => setShowedPanel(ShownPanelsEnum.None)}
            clickOnSave={refresh}
            windowDescription={TpSurveyActivateWindowDescription}
            errorCode={'ATSP136'}
          />
        )}
      </div>
    );
  }

  const renderCancelAndSubmitButtons = () => (
    <ButtonFooterContainer>
      <FigmaButton
        className='applySurveyPanelButton'
        label='Submit'
        submit={true}
        iconName={`fa-solid fa-upload ${saving ? ' fa-spin' : ''}`}
        disabled={saving || !itemList.find((f) => f.Selected)}
        type={ButtonTypeEnum.ExtraLargeNormal}
        color={ButtonColorsEnum.Primary}
        iconPosition={IconPositionEnum.Left}
        onClick={handleOnSubmit}
      />
    </ButtonFooterContainer>
  );

  if (props.isOverWindow) {
    return (
      <>
        {renderPanels()}
        <OverWindow
          title={'Associate Third-Party Survey'}
          clickOnCancel={() => {
            if (!saving) props.clickOnCancel(false);
          }}
          closeOnClickOutside={false}
          iconName='fa-solid fa-plus-circle'
          zIndex={1050}
          className='applySurveyPanel top-of-boxFigma'
          verticalScroll={false}
        >
          <div className='container-fluid verticalScrollForSearch height50vh'>
            <TabOfDataTable
              itemList={itemList}
              type={ProjectAssociableTpSurveyItem}
              serviceFunction={TpSurveyService.GetTpSurveyItemList}
              changeOfItemListFunction={setItemList}
              convertDBItemsFunction={TpSurveyService.ConvertToProjectAssociableTpSurveyItem}
              showSearchStrip={true}
              singleSearchLinePlaceholder='Search in Survey ID or Name...'
              singleSearchLine={true}
              enableUrlPush={false}
              searchParamsType={TpSurveySearchParams}
              clickOnStartSearch={setSearchItem}
              searchItem={searchItem}
              isFilterDisabled={true}
              isRefreshDisabled={true}
              forceClearCacheOnSearch={true}
            />
            {renderCancelAndSubmitButtons()}
          </div>
        </OverWindow>
      </>
    );
  }

  return null;
};

export default AssociateTpSurveyPanel;
